import { render, staticRenderFns } from "./ReviewComponent.vue?vue&type=template&id=93d07cb4&scoped=true"
import script from "./ReviewComponent.vue?vue&type=script&lang=js"
export * from "./ReviewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d07cb4",
  null
  
)

export default component.exports